import useOnScreen from 'support/hooks/use-on-screen'

export default function WhenOnScreen ({ children, once = false }) {
  const [ref, setRef] = React.useState()

  const isOnScreeen = useOnScreen(ref, once)

  return (
    <div ref={setRef} className='w-full h-full'>
      {isOnScreeen
        ? children
        : null}
    </div>
  )
}
